import { z } from 'zod'
import { STRINGS } from '$lib/constants/strings'
import type { Language } from '@bond/components'
import type { PostAccessAuthenticateBody } from '@bond/bruce-api/api/access/authenticate/body'

export const schema = (lang: Language) => {
  return z.object({
    email: z.string().email(STRINGS[lang].LOGIN_EMAIL_INVALID),
    password: z.string(),
    '2fa_token': z.string().optional(),
  }) satisfies z.ZodType<Omit<PostAccessAuthenticateBody, 'authenticator'>>
}

export type FormInput = z.input<ReturnType<typeof schema>>
export type FormOutput = z.output<ReturnType<typeof schema>>
